module.exports = __webpack_public_path__ + "static/img/ai.3b9799e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/light/ai.png
// module id = cxWu
// module chunks = 1